import { render } from "./Loading.vue?vue&type=template&id=1d350d8e"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=1d350d8e&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__